import { datadogLoggingClientManager } from "@/manager/datadog-logging-client";
import { datadogRumClientManager } from "@/manager/datadog-rum-client";
import { AppStore } from "@/store/AppStore";

export const initializeAccountObservability = async ({ store }: { store: AppStore }) => {
  const datadogLogger = datadogLoggingClientManager.instance();
  const datadogRum = datadogRumClientManager.instance();

  const { id, profileEmailAddress, profileDisplayName } = store.account.myAccount;

  datadogLogger.setUser({
    id,
    email: profileEmailAddress,
    name: profileDisplayName,
  });

  datadogRum.setUser({
    id,
    email: profileEmailAddress,
    name: profileDisplayName,
  });
};
